// extracted by mini-css-extract-plugin
export default {"div":"EventCard_div__Uh15z","img":"EventCard_img__8FkQa","h1":"EventCard_h1__jyalF","p":"EventCard_p__Wo+1U"};